 <template>
  <div
    class="c-tab-container"
    ref="tabs"
  >
     <div class="c-tab" :class="activeId==='0'?'active':''"  @click="changeSubject('0')">
      全部</div>
      <div
       class="c-tab"
        v-for="item in subject_list"
        :key="item.subjectId"
        @click="changeSubject(item.subjectId)"
        :class="activeId===item.subjectId?'active':''"
      >
     {{item.subjectName}}
      </div>
  </div>
</template>

<script>
export default {
  name: 'CTabs',
  props: {
    activeId: {
      type: String,
      default: '0',
    },
    subject_list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },

  methods: {
    changeSubject(subjectId) {
      this.$emit('changeSubject', subjectId);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-tab-container {
    height: 40px;
    background:  #F0F2F5;;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 2px;
}
.c-tab {
  width: 101px;
  height: 36px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #303133;
  cursor: pointer;
}
 .active {
    color: #1989FA;
    background-color: #fff;
 }
</style>
